export default "__VITE_ASSET__Baq3EYfI__"